import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import Common from '../utilities/common';

export interface IExtraccionesVerticalesChartState {
    data: any[];
}

export default class ExtraccionesVerticalesChart extends React.Component<{}, IExtraccionesVerticalesChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Extracciones por vertical
                        </Typography>
                    </Box>
                    <BarChart
                        dataset={this.state.data}
                        xAxis={[{ scaleType: 'band', dataKey: 'label' }]}
                        series={[
                            { dataKey: 'value', label: 'Extracciones', color: Common.MAN_BORDER_COLOR }
                        ]}
                        height={350}
                        margin={{
                            bottom: 100
                        }}
                        slotProps={
                            {
                                legend: {
                                    direction: 'row',
                                    position: {
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    },
                                    itemMarkWidth: 20,
                                    itemMarkHeight: 6,
                                    markGap: 5,
                                    itemGap: 10,
                                    labelStyle: {
                                        fontSize: 11
                                    }
                                }
                            }
                        }
                    />
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/extracciones/verticales`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.label = response[i].name;
                dataItem.value = response[i].total;

                data.push(dataItem);
            }

            const dataWithColors = Common.SetColors(data);
            
            this.setState({
                data: dataWithColors
            })
        })
    }
}